import sessionReader from './SessionReader';
import storeManager from '../../store/StoreManager';

const timeReader = {
    timeHasExpired({ time } = storeManager.getState()) {
        return time.timeRemaining === 0 && sessionReader.isContextExam();
    },
};

export default timeReader;
